import {FC} from "react";
import styled from "@emotion/styled";
import {PlayerAvatar} from "components";
import bg from "assets/images/playerModal/playerProfileBg.jpeg";
import {breakpoints} from "assets/theme";

const Wrapper = styled.div`
	display: flex;
	padding: 20px;
	gap: 12px;
	color: ${({theme}) => theme.colorPalette.white};
	text-align: left;
	position: relative;
	z-index: 0;
`;

const AvatarWrapper = styled.div`
	min-width: 80px;
	height: 86px;

	&.circle {
		min-width: 80px;
		height: 80px;
	}

	div,
	img {
		background: transparent;
	}

	@media (min-width: ${breakpoints.medium}) {
		min-width: 120px;
		height: 128px;

		&.circle {
			min-width: 120px;
			height: 120px;
		}
	}
`;

const Container = styled.div`
	display: flex;
	flex-direction: column;
	flex-grow: 1;
	gap: 4px;

	@media (min-width: ${breakpoints.medium}) {
		flex-direction: row;
		justify-content: space-between;
	}
`;

const Info = styled.div`
	font-family: "Hind", sans-serif;
	font-weight: 500;
	display: flex;
	flex-direction: column;
	gap: 4px;

	@media (min-width: ${breakpoints.medium}) {
		margin-top: 16px;
	}
`;

const Name = styled.div`
	font-family: "Khand", sans-serif;
	font-weight: 700;
	font-size: 28px;
	line-height: 120%;
	letter-spacing: 0.2px;
	text-transform: uppercase;

	@media (min-width: ${breakpoints.medium}) {
		font-size: 32px;
	}
`;

const Background = styled.img`
	position: absolute;
	width: 100%;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	object-fit: cover;
	z-index: -1;
	background: black;
`;

interface IDetailsInfo {
	title: string;
	src: string;
	altSrc?: string;
	alt: string;
	name: string;
	squadName?: string;
	isCaptain?: boolean;
	className?: string;
}

export const PlayerDetailsInfo: FC<IDetailsInfo> = ({
	name,
	src,
	title,
	squadName,
	isCaptain,
	alt,
	altSrc,
	className,
}) => {
	return (
		<Wrapper>
			<Background src={bg} />

			<AvatarWrapper>
				<PlayerAvatar
					className={className}
					src={src}
					altSrc={altSrc}
					alt={alt}
					width="100%"
					height="100%"
				/>
			</AvatarWrapper>

			<Container>
				<Info>
					<Name>{name}</Name>
					{squadName && <div>{squadName}</div>}
					<div>{title}</div>
				</Info>
			</Container>
		</Wrapper>
	);
};
